import { isRedirect } from "@tanstack/react-router"
import { createMiddleware, createStart } from "@tanstack/react-start"

// https://github.com/TanStack/router/issues/4460#issuecomment-3015836376
const convertRedirectErrorToExceptionMiddleware = createMiddleware({
  type: "function",
}).server(async ({ next }) => {
  const result = await next()

  if ("error" in result && isRedirect(result.error)) {
    throw result.error
  }

  return result
})

export const startInstance = createStart(() => ({
  defaultSsr: true,
  functionMiddleware: [convertRedirectErrorToExceptionMiddleware],
}))
